export var DumpServicePriority;
(function (DumpServicePriority) {
    DumpServicePriority[DumpServicePriority["LOW"] = 0] = "LOW";
    DumpServicePriority[DumpServicePriority["MEDIUM"] = 1] = "MEDIUM";
    DumpServicePriority[DumpServicePriority["HIGH"] = 2] = "HIGH";
})(DumpServicePriority || (DumpServicePriority = {}));
;
